<br />
This is inside the about angular component
